import React, { useEffect, useState } from 'react';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { callFunctionConditionallyWithWarningCurry } from '../../utils/utils';
import styles from './LineDropdownSelector.module.css';
import Select from 'react-select';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const LineDropdownSelector = ({
  hasActiveEdits,
  isDarkStyle,
  height = 30,
  sequenceAdherenceDashBoard,
  setLineValueForSequenceAdherence,
  plantValue,
}) => {
  const [line, setLine] = usePlantAndLinesStore().lineState;
  const [lineOptions] = usePlantAndLinesStore().lineOptions;
  const [LineForSeqAdherence, setLineForSeqAdherence] = useState({
    value: '9000',
    label: 'ALL',
  });

  const handleLineChange = valueObject => {
    setLine(valueObject);
  };
  const handleLineChangeForSeqAdherence = value => {
    setLineForSeqAdherence(value);
    setLineValueForSequenceAdherence(value);
  };

  const customStyles = {
    control: provided => ({
      ...provided,
      width: 120,
      minWidth: 120,
      height: height,
      minHeight: height,
      fontSize: '12px',
      background: 'none',
      paddingTop: 0,
      paddingBottom: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      width: 120,
      minWidth: 120,
      height: 30,
      minHeight: 30,
      fontSize: '12px',
    }),
    dropdownIndicator: provided => ({
      ...provided,
      width: 30,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    indicatorSeparator: () => ({ display: 'none' }),
  };

  const AddAlltoLineOptions = lineOptions => {
    if (plantValue.label === 'ALL') {
      const lineOptionsForSeqAdherence = [{ value: '9000', label: 'ALL' }];
      return lineOptionsForSeqAdherence;
    } else {
      const lineOptionsForSeqAdherence = lineOptions.map(record => record);
      lineOptionsForSeqAdherence.unshift({ value: '9000', label: 'ALL' });
      return lineOptionsForSeqAdherence;
    }
  };

  useEffect(() => {
    if (sequenceAdherenceDashBoard) {
      setLineValueForSequenceAdherence({
        value: '9000',
        label: 'ALL',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return sequenceAdherenceDashBoard === 'Seq. Adherence' ? (
    <Select
      value={LineForSeqAdherence}
      styles={customStyles}
      className={clsx(styles.dropdown, isDarkStyle && styles.dropdownDark)}
      classNamePrefix="select-line"
      onChange={callFunctionConditionallyWithWarningCurry(
        handleLineChangeForSeqAdherence,
        hasActiveEdits,
      )}
      options={AddAlltoLineOptions(lineOptions)}
    />
  ) : (
    <Select
      value={line}
      styles={customStyles}
      className={clsx(styles.dropdown, isDarkStyle && styles.dropdownDark)}
      classNamePrefix="select-line"
      onChange={callFunctionConditionallyWithWarningCurry(
        handleLineChange,
        hasActiveEdits,
      )}
      options={lineOptions}
    />
  );
};

LineDropdownSelector.prototypes = {
  hasActiveEdits: PropTypes.bool,
  isDarkStyle: PropTypes.bool,
  height: PropTypes.number,
};
export default LineDropdownSelector;
